import FileUpload, { FileUploadProps } from '@ui/components/FileUpload/FileUpload'
import { DocumentFileExtensionType, getImageFileExtensions } from '@ui/components/FileUpload/types'

export const DocumentFileUpload: React.FC<FileUploadProps> = (props) => {
  return (
    <FileUpload
      {...props}
      acceptType={props.acceptType ?? [...getImageFileExtensions(), DocumentFileExtensionType.PDF]}
    />
  )
}
